module.exports = __webpack_public_path__ + "static/5StoryRichIndieGamesCuteFroggyProtagonists1-83831fd8009ddb15b7dfdeb6782126d8.webp";